/* Puravel DE/EN language toggle.
   The storefront content is authored in German; theme UI strings follow the
   Shopify locale. Pairs below match either side, so the toggle keeps working
   after the store's default language is switched to German. */
(function () {
  'use strict';

  var PAIRS = [
    /* Announcement bar */
    ["Kostenloser Versand aus Deutschland 🇩🇪 · 30 Tage Geld-zurück-Garantie",
     "Free shipping from Germany 🇩🇪 · 30-day money-back guarantee"],
    /* Navigation */
    ["Start", "Home"],
    ["Katalog", "Catalog"],
    ["Kontakt", "Contact"],
    /* Hero */
    ["Reine Dampfkraft", "Pure steam power"],
    ["Tiefenreinigung. Ganz ohne Chemie.", "Deep cleaning. Zero chemicals."],
    ["Jetzt entdecken", "Discover now"],
    /* Trust icons */
    ["Versand aus Deutschland", "Shipped from Germany"],
    ["Kostenlos geliefert in 3–7 Werktagen.", "Delivered free in 3–7 business days."],
    ["2 Jahre Garantie", "2-year warranty"],
    ["Durchdachte Qualität, auf die du dich verlässt.", "Thoughtful quality you can rely on."],
    ["30 Tage Geld-zurück", "30-day money-back"],
    ["Nicht überzeugt? Volle Rückerstattung.", "Not convinced? Full refund."],
    ["100 % chemiefrei", "100% chemical-free"],
    ["Hygienisch rein – nur mit Wasser.", "Hygienically clean – with water alone."],
    /* Marquee */
    ["Reine Dampfkraft — chemiefrei sauber — 99,9 % der Bakterien entfernt —",
     "Pure steam power — chemical-free clean — removes 99.9% of bacteria —"],
    /* Featured collection */
    ["Das Sortiment", "The range"],
    ["Ein Gerät. Alles dabei.", "One device. Everything included."],
    ["Der Puravel Dampfreiniger kommt mit komplettem 12-teiligem Zubehör – Ersatzteile sind aktuell ausverkauft.",
     "The Puravel steam cleaner ships with a complete 12-piece accessory kit – spare parts are currently sold out."],
    ["Zum Dampfreiniger", "Shop the steam cleaner"],
    /* Product titles */
    ["Puravel Dampfreiniger", "Puravel Steam Cleaner"],
    ["Puravel Ersatz-Düsen-Set (3-teilig)", "Puravel Spare Nozzle Set (3-piece)"],
    ["Puravel Ersatz-Flexschlauch", "Puravel Spare Flex Hose"],
    ["Puravel Ersatz-Fensteraufsatz", "Puravel Spare Window Attachment"],
    ["Puravel Mikrofaser-Bezüge (2er-Nachfüllpack)", "Puravel Microfibre Covers (2-pack refill)"],
    /* Bath story */
    ["Für jeden Raum", "For every room"],
    ["Küche, Bad, Polster & Auto.", "Kitchen, bath, upholstery & car."],
    ["Heißer Dampf mit 3 bar Druck löst Fett, Kalk und eingetrocknete Flecken – überall dort, wo Schrubben bisher nichts gebracht hat. Sicher für Kinder und Haustiere.",
     "Hot steam at 3 bar of pressure dissolves grease, limescale and dried-in stains – everywhere scrubbing has failed so far. Safe for children and pets."],
    ["Jetzt für 69,90 € sichern", "Get yours for €69.90"],
    /* Stats */
    ["Heißer Dampf", "Hot steam"],
    ["Löst hartnäckiges Fett und Kalk in Sekunden – ganz ohne Reinigungsmittel.",
     "Dissolves stubborn grease and limescale in seconds – no cleaning agents needed."],
    ["bar Druck", "bar of pressure"],
    ["Kraftvoller Druckdampf erreicht auch Fugen, Ritzen und schwer zugängliche Ecken.",
     "Powerful pressurised steam reaches grout lines, crevices and hard-to-reach corners."],
    ["Teile Zubehör", "accessory pieces"],
    ["Die passende Düse für jede Aufgabe – komplett im Lieferumfang enthalten.",
     "The right nozzle for every task – all included in the box."],
    /* FAQ */
    ["Fragen? Wir sind für dich da.", "Questions? We're here for you."],
    ["Hier findest du Antworten auf die häufigsten Fragen. Noch etwas unklar? Schreib uns – wir melden uns schnell zurück.",
     "Find answers to the most common questions here. Still unsure? Write to us – we'll get back to you quickly."],
    ["Unser Kundenservice antwortet Montag bis Freitag.", "Our customer service replies Monday to Friday."],
    ["Durchschnittliche Antwortzeit: 24 h", "Average response time: 24 h"],
    ["Wie schnell wird geliefert?", "How fast is delivery?"],
    ["Wir versenden direkt aus unserem Lager in Deutschland. Die Lieferung dauert in der Regel 3–7 Werktage und ist kostenlos.",
     "We ship directly from our warehouse in Germany. Delivery usually takes 3–7 business days and is free."],
    ["Funktioniert die Reinigung wirklich ohne Chemie?", "Does it really clean without any chemicals?"],
    ["Ja. Der heiße Druckdampf löst Fett, Kalk und Flecken rein physikalisch und entfernt bis zu 99,9 % der Bakterien – nur mit Leitungswasser. Das ist sicher für Kinder und Haustiere.",
     "Yes. The hot pressurised steam dissolves grease, limescale and stains purely physically and removes up to 99.9% of bacteria – with nothing but tap water. Safe for children and pets."],
    ["Für welche Oberflächen ist der Dampfreiniger geeignet?", "Which surfaces is the steam cleaner suitable for?"],
    ["Küche (Herd, Backofen, Dunstabzug), Bad (Fliesen, Fugen, Armaturen), Fenster und Spiegel, Polster und Matratzen sowie der Auto-Innenraum. Das 12-teilige Zubehör enthält für jede Aufgabe den passenden Aufsatz.",
     "Kitchen (hob, oven, extractor), bathroom (tiles, grout, fittings), windows and mirrors, upholstery and mattresses, plus your car interior. The 12-piece kit includes the right attachment for every task."],
    ["Welche Garantie bekomme ich?", "What warranty do I get?"],
    ["Du erhältst 2 Jahre Garantie auf das Gerät – und zusätzlich eine 30-Tage-Geld-zurück-Garantie: Wenn du nicht überzeugt bist, erstatten wir dir den vollen Kaufpreis.",
     "You get a 2-year warranty on the device – plus a 30-day money-back guarantee: if you're not convinced, we'll refund the full purchase price."],
    ["Welches Wasser soll ich verwenden?", "Which water should I use?"],
    ["Ganz normales Leitungswasser. Bitte kein destilliertes Wasser verwenden, da es die Dampferzeugung beeinträchtigt. Nach der Nutzung das Restwasser einfach entleeren.",
     "Plain tap water. Please don't use distilled water, as it affects steam generation. Simply empty the remaining water after use."],
    /* Footer */
    ["Kostenloser Versand · Lieferung in 3–7 Werktagen.", "Free shipping · delivered in 3–7 business days."],
    ["Persönlicher Support", "Personal support"],
    ["Wir antworten innerhalb von 24 Stunden.", "We reply within 24 hours."],
    ["Plus 30 Tage Geld-zurück-Garantie.", "Plus a 30-day money-back guarantee."],
    ["Sichere Bezahlung", "Secure payment"],
    ["SSL-verschlüsselt mit geprüften Zahlarten.", "SSL-encrypted with trusted payment methods."],
    ["Neuigkeiten & persönliche Angebote", "News & personal offers"],
    ["Melde dich an und erhalte Pflege-Tipps, Neuigkeiten und persönliche Angebote – direkt in dein Postfach.",
     "Sign up for care tips, news and personal offers – straight to your inbox."],
    ["Über Puravel", "About Puravel"],
    ["Puravel steht für chemiefreie Tiefenreinigung mit reiner Dampfkraft – für ein hygienisch sauberes Zuhause, sicher für Kinder und Haustiere.",
     "Puravel stands for chemical-free deep cleaning with pure steam power – for a hygienically clean home, safe for children and pets."],
    /* Theme UI strings (follow the Shopify locale) */
    ["Ausverkauft", "Sold out"],
    ["Suche", "Search"],
    ["Warenkorb", "Cart"],
    ["Menü", "Menu"],
    ["Deine E-Mail", "Your email"],
    ["E-Mail", "Email"],
    ["Abonnieren", "Subscribe"],
    ["Dein Warenkorb ist leer", "Your cart is empty"],
    ["Angebot", "Sale"],
    ["Spare 50 %", "Save 50%"],
    ["Normaler Preis", "Regular price"],
    ["Angebotspreis", "Sale price"],
    /* Product page: description */
    ["Reine Dampfkraft. Immer griffbereit.", "Pure steam power. Always within reach."],
    ["Fett auf dem Herd, Kalk im Bad, Flecken auf dem Sofa, Schmutz in jeder Fuge \u2013 der Puravel Dampfreiniger l\u00f6st all das mit",
     "Grease on the hob, limescale in the bathroom, stains on the sofa, dirt in every grout line \u2013 the Puravel steam cleaner dissolves it all with"],
    ["reinem, hei\u00dfem Dampf unter Druck", "pure, hot pressurised steam"],
    [". Kein Schrubben, keine aggressiven Reiniger, kein R\u00fcckstand. Wasser einf\u00fcllen, aufheizen, spr\u00fchen \u2013 fertig.",
     ". No scrubbing, no harsh cleaners, no residue. Fill with water, heat up, spray \u2013 done."],
    ["Hei\u00dfer Druckdampf", "Hot pressurised steam"],
    ["\u2013 3,0 bar & bis zu 150 \u00b0C l\u00f6sen hartn\u00e4ckiges Fett, Kalk & eingetrocknete Flecken",
     "\u2013 3.0 bar & up to 150 \u00b0C dissolve stubborn grease, limescale & dried-in stains"],
    ["Chemiefrei & hygienisch", "Chemical-free & hygienic"],
    ["\u2013 t\u00f6tet bis zu 99,9 % Bakterien nur mit Wasser \u2013 sicher f\u00fcr Kinder & Haustiere",
     "\u2013 kills up to 99.9% of bacteria with water alone \u2013 safe for children & pets"],
    ["Leicht & handlich", "Light & handy"],
    ["\u2013 kompaktes Handger\u00e4t, sofort griffbereit, erreicht m\u00fchelos jede Ecke",
     "\u2013 compact handheld, ready to grab, effortlessly reaches every corner"],
    ["12-teiliges Zubeh\u00f6r-Set", "12-piece accessory kit"],
    ["\u2013 die passende D\u00fcse f\u00fcr jede Aufgabe: K\u00fcche, Bad, Fugen, Fenster, Polster & Auto",
     "\u2013 the right nozzle for every task: kitchen, bathroom, grout, windows, upholstery & car"],
    ["Durchdachte Sicherheit", "Thoughtful safety"],
    ["\u2013 Kindersicherung am Dampfknopf & Sicherheitsverschluss",
     "\u2013 child lock on the steam trigger & safety cap"],
    ["2,8 m Kabel", "2.8 m cable"],
    ["\u2013 volle Bewegungsfreiheit beim Reinigen", "\u2013 full freedom of movement while cleaning"],
    ["\ud83c\udde9\ud83c\uddea Versand aus Deutschland \u00b7 kostenlos  |  \ud83d\udee1\ufe0f 2 Jahre Garantie  |  \u21a9\ufe0f 30 Tage Geld-zur\u00fcck-Garantie",
     "\ud83c\udde9\ud83c\uddea Ships from Germany \u00b7 free  |  \ud83d\udee1\ufe0f 2-year warranty  |  \u21a9\ufe0f 30-day money-back guarantee"],
    /* Product page: UI (native de locale strings) */
    ["In den Warenkorb", "Add to cart"],
    ["Jetzt kaufen", "Buy it now"],
    ["Menge", "Quantity"],
    ["Inkl. Steuern.", "Tax included."],
    ["Versand", "Shipping"],
    ["wird beim Checkout berechnet", "calculated at checkout"],
    ["Nicht vorr\u00e4tig", "Out of stock"],
    ["Das k\u00f6nnte dir auch gefallen", "You may also like"]
  ];

  var DE = 0, EN = 1;
  var toDE = Object.create(null), toEN = Object.create(null);
  PAIRS.forEach(function (p) {
    toEN[p[DE]] = p[EN]; toEN[p[EN]] = p[EN];
    toDE[p[EN]] = p[DE]; toDE[p[DE]] = p[DE];
  });

  var originals = new WeakMap();

  /* Session-scoped on purpose: every new visit starts in German; the EN
     choice only sticks while the visitor keeps browsing in the same tab. */
  function currentLang() {
    try { return sessionStorage.getItem('puravel-lang') || 'de'; } catch (e) { return 'de'; }
  }

  function translateNode(node, map) {
    var original = originals.get(node);
    if (original === undefined) { original = node.nodeValue; originals.set(node, original); }
    var trimmed = original.trim();
    if (!trimmed) return;
    var target = map[trimmed];
    if (target !== undefined) {
      var replaced = original.replace(trimmed, target);
      if (node.nodeValue !== replaced) node.nodeValue = replaced;
    } else if (node.nodeValue !== original) {
      node.nodeValue = original;
    }
  }

  function translateTree(root, map) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = walker.nextNode())) translateNode(n, map);
  }

  function translateAttrs(map) {
    var els = document.querySelectorAll('input[placeholder], [aria-label]');
    els.forEach(function (el) {
      ['placeholder', 'aria-label'].forEach(function (attr) {
        var v = el.getAttribute(attr);
        if (!v) return;
        var key = 'puravelOrig' + attr;
        if (el.dataset[key] === undefined) el.dataset[key] = v;
        var orig = el.dataset[key];
        var target = map[orig.trim()];
        el.setAttribute(attr, target !== undefined ? orig.replace(orig.trim(), target) : orig);
      });
    });
  }

  var applying = false;
  function apply(lang) {
    applying = true;
    var map = lang === 'en' ? toEN : toDE;
    translateTree(document.body, map);
    translateAttrs(map);
    document.documentElement.setAttribute('lang', lang);
    document.querySelectorAll('.puravel-lang__btn').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.lang === lang ? 'true' : 'false');
    });
    applying = false;
  }

  function setLang(lang) {
    try {
      sessionStorage.setItem('puravel-lang', lang);
      localStorage.removeItem('puravel-lang'); /* clear legacy persisted choice */
    } catch (e) {}
    apply(lang);
  }

  function buildToggle() {
    if (document.querySelector('.puravel-lang')) return;
    var list = document.querySelector('.header__secondary-nav .header__icon-list');
    if (!list) return;
    var li = document.createElement('li');
    li.className = 'puravel-lang';
    ['de', 'en'].forEach(function (lang, i) {
      if (i) {
        var sep = document.createElement('span');
        sep.className = 'puravel-lang__sep';
        sep.textContent = '/';
        li.appendChild(sep);
      }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'puravel-lang__btn';
      b.dataset.lang = lang;
      b.textContent = lang.toUpperCase();
      b.setAttribute('aria-label', lang === 'de' ? 'Deutsch' : 'English');
      b.addEventListener('click', function () { setLang(lang); });
      li.appendChild(b);
    });
    list.insertBefore(li, list.firstChild);

    var style = document.createElement('style');
    style.textContent =
      '.puravel-lang{display:flex;align-items:center;gap:.375rem;margin-inline-end:.5rem}' +
      '.puravel-lang__sep{opacity:.35}' +
      '.puravel-lang__btn{background:none;border:none;padding:.25rem .125rem;cursor:pointer;color:currentColor;' +
      'font:inherit;font-size:.8125rem;font-weight:700;letter-spacing:.08em;opacity:.4;transition:opacity .2s}' +
      '.puravel-lang__btn:hover{opacity:.75}' +
      '.puravel-lang__btn[aria-pressed="true"]{opacity:1;text-decoration:underline;text-underline-offset:.3em}' +
      '@media (max-width: 699px){' +
      '.puravel-lang{gap:.125rem;margin-inline-end:.125rem}' +
      '.puravel-lang__btn{font-size:.6875rem;letter-spacing:.04em;padding:.25rem 0}' +
      '.puravel-lang__sep{display:none}' +
      '.puravel-lang__btn[aria-pressed="false"]{opacity:.35}}';
    document.head.appendChild(style);
  }

  function init() {
    buildToggle();
    apply(currentLang());
    var observer = new MutationObserver(function (muts) {
      if (applying) return;
      var lang = currentLang();
      var map = lang === 'en' ? toEN : toDE;
      applying = true;
      muts.forEach(function (m) {
        if (m.type === 'characterData') {
          originals.set(m.target, m.target.nodeValue);
          translateNode(m.target, map);
        }
        m.addedNodes && m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) translateTree(node, map);
          else if (node.nodeType === 3) translateNode(node, map);
        });
      });
      buildToggle();
      applying = false;
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
